import DateTimePicker from './DateTimePicker';
import { showDatePicker, showRangePicker } from './show';
import RangePicker from './RangePicker';
DateTimePicker.show = showDatePicker;
RangePicker.show = showRangePicker;
DateTimePicker.RangePicker = RangePicker;
export default DateTimePicker;
export { DateTimePicker, RangePicker };
